import { combineReducers } from 'redux';

import api from './api';
import app from './app';
import gCache from '../common/reducers/gCache';
import dlareducer from '../common/reducers/dlareducer'

import { reducer as auth } from '../common/auth/index';


export  default combineReducers({
    api,
    app,
    gCache,
    dlareducer,
    auth
});

